import imgCongratulation from '@assets/web-v3-images/congratulation.png';
import imgExit from '@assets/web-v3-images/icons/exits.png';
import Popups from '..';
import '@/assets/styles/web-v3-styles/popups/ui-2/index.scss'
import { useTranslation } from 'react-i18next';

//UI-2 dùng cho các popup mở kho báu, chúc mừng lên hạng, kết quả đánh giá.....
export default function FrameTreasure({
	open, onOpenChange, title = 'Demo', children, hiddenIconExit = false
}) {
	const { t } = useTranslation()
	return (
		<Popups
			open={open}
			onOpenChange={onOpenChange}
			className="
			!bg-transparent
			!shadow-none
			!p-0
			!w-[95vw]
			!max-w-[550px]
			mx-auto
			!overflow-hidden
			"
		>
			<div className="flex flex-col w-full relative">
				{!hiddenIconExit &&
					<img src={imgExit} className="w-[10%] h-auto absolute top-[17%] right-[7px] btn-click-active z-100" onClick={() => onOpenChange(!open)} />
				}
				<div className='relative'>
					<img
						src={imgCongratulation}
						alt="congratulation"
						className="block w-full h-auto"
					/>
					<div className="absolute bottom-[17%] left-1/2 -translate-x-1/2">
						{/* Viền */}
						<span
							className="absolute inset-0 font-extrabold select-none 
							text-[25px] sm:text-[40px]"
							style={{
								WebkitTextStroke: "4px rgba(255, 105, 46, 1)",
								color: "transparent",
								paintOrder: "stroke fill",
								textShadow: "0 4px 4px rgba(0, 0, 0, 0.25)",
							}}
						>
							{t(title)}
						</span>
						{/* Chữ */}
						<span
							className="relative font-extrabold bg-clip-text text-transparent
							text-[25px] sm:text-[40px]
							"
							style={{
								backgroundImage:
									"linear-gradient(180deg, rgba(254, 247, 195, 1) 0%, rgba(253, 226, 114, 1) 100%)",
							}}
						>
							{t(title)}
						</span>
					</div>
				</div>

				{children}
			</div>
		</Popups>
	)
}
